var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass:
          "bg-white text-white pt-2 pb-2 pl-1 pr-1 mb-0 d-flex justify-content-between",
      },
      [
        _c("div", [
          _c("span", { staticClass: "font-medium-3 text-light" }, [
            _vm._v(_vm._s(_vm.__("job.new_position_open")) + ":"),
          ]),
          _c("br"),
          _vm._v(" "),
          _c(
            "a",
            {
              staticStyle: { color: "#000000" },
              attrs: { href: "/member/job/" + this.data.slug },
            },
            [
              _c("span", {
                staticClass: "h3",
                domProps: { textContent: _vm._s(this.data.title) },
              }),
            ]
          ),
          _vm._v(" "),
          _c("div", [
            _c("i", {
              staticClass: "feather icon-briefcase text bold-700",
              staticStyle: { color: "#3399fe !important" },
            }),
            _vm._v(" "),
            _c("span", {
              staticClass: "text-bold-700",
              staticStyle: { color: "#3399fe !important" },
              domProps: { textContent: _vm._s(this.data.employment_type) },
            }),
          ]),
        ]),
        _vm._v(" "),
        this.data.organisation_logo !== null
          ? _c("div", [
              _c("img", {
                attrs: { src: this.data.organisation_logo.url, width: "75" },
              }),
            ])
          : _vm._e(),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "card-content" }, [
      _c("div", { staticClass: "pt-1 pl-1 pr-1 pb-05 border-top" }, [
        _vm.collapse_body
          ? _c("div", {
              directives: [{ name: "linkified", rawName: "v-linkified" }],
              staticClass: "breakAll image-resize textBox",
              domProps: { innerHTML: _vm._s(_vm.data.position_description) },
            })
          : _c("div", {
              directives: [{ name: "linkified", rawName: "v-linkified" }],
              ref: "textBox",
              class: _vm.class_body + " image-resize textBox",
              domProps: { innerHTML: _vm._s(_vm.data.position_description) },
            }),
        _vm._v(" "),
        _vm.enable_read_more
          ? _c("div", [
              _vm.collapse_body
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-link font-small-3 mt-05 mb-05 p-0",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          _vm.collapse_body = false
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.__("globals.read_less")) +
                          " "
                      ),
                      _c("i", { staticClass: "fa fa-chevron-up" }),
                    ]
                  )
                : _c(
                    "button",
                    {
                      staticClass: "btn btn-link font-small-3 mt-05 mb-05 p-0",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          _vm.collapse_body = true
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.__("globals.read_more")) +
                          " "
                      ),
                      _c("i", { staticClass: "fa fa-chevron-down" }),
                    ]
                  ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "d-flex ml-1 mr-1 mt-05 mb-0 pb-05 align-items-center justify-content-start",
        },
        [
          this.data.hide_salary === 0
            ? _c(
                "span",
                {
                  staticClass: "font-small-3 text-bold-700",
                  staticStyle: { color: "black" },
                },
                [
                  _vm._v(
                    _vm._s(_vm.__("job.salary")) +
                      ": " +
                      _vm._s(this.data.custom_salary)
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.user.confirmed === true
            ? _c("div", { staticClass: "ml-auto" }, [
                this.data.isPositionClosed === false
                  ? _c("span", [
                      this.data.external_link !== null
                        ? _c("span", { staticClass: "ml-auto" }, [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "btn btn-sm btn-primary waves-effect waves-light",
                                attrs: {
                                  href: this.data.external_link,
                                  target: "_blank",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.__("job.form.buttons.view_job_site")
                                  ) + " "
                                ),
                                _c("i", {
                                  staticClass: "feather icon-chevron-right",
                                }),
                              ]
                            ),
                          ])
                        : _c("span", [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "btn btn-sm btn-primary waves-effect waves-light",
                                attrs: {
                                  href:
                                    "/member/job-applies?apply=" +
                                    this.data.slug,
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.__("job.form.buttons.apply")) + " "
                                ),
                                _c("i", { staticClass: "fas fa-user-check" }),
                              ]
                            ),
                          ]),
                    ])
                  : _c(
                      "div",
                      {
                        staticClass:
                          "btn btn-sm btn-outline-danger p-05 rounded ml-auto",
                      },
                      [
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.__("job.headers.member.title_position_closed")
                            )
                          ),
                        ]),
                      ]
                    ),
              ])
            : _vm._e(),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }